import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import {
    chain,
    WaitForData,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";

type HandlerType = Handler<{
    cartId?: string;
    onSuccess: () => void;
}>;

const getShipTosParameter = (props: Parameters<HandlerType>[0]): GetShipTosApiParameter | undefined => {
    const state = props.getState();
    const cart = props.parameter.cartId
        ? getCartState(state, props.parameter.cartId).value
        : getCurrentCartState(state).value;

    if (!cart?.billToId) {
        return undefined;
    }

    const parameter: GetShipTosApiParameter = {
        billToId: cart.billToId,
        expand: ["validation"],
        exclude: ["showAll"],
    };

    return parameter;
};

export const PreloadShipTos: HandlerType = props => {
    const parameter = getShipTosParameter(props);
    if (!parameter) {
        return;
    }

    const shipTosDataView = getShipTosDataView(props.getState(), parameter);
    if (!shipTosDataView.value && !shipTosDataView.isLoading) {
        props.dispatch(loadShipTos(parameter));
    }
};

export const WaitForShipTos: HandlerType = async props => {
    await waitFor(() => {
        const parameter = getShipTosParameter(props);
        if (!parameter) {
            return true;
        }

        const shipTosDataView = getShipTosDataView(props.getState(), parameter);
        return !!shipTosDataView.value && !shipTosDataView.isLoading;
    });
};

addToChainAfter(chain, WaitForData, PreloadShipTos);
addToChainAfter(chain, PreloadShipTos, WaitForShipTos);